export const ManageDataHome = () => {
  return (
    <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'row'}}>
      <a href= "/manageUnitsData">Update Unit Data</a>
      &nbsp;|&nbsp;
      <a href= "/manageEnhancementsData">Update Enhancements Data</a>
    </div>
  );
}
